import { useCallback, useMemo, useState } from "react"

export const useDiscardConfirm = ({ isDirty, onClose }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const handleCloseRequest = useCallback(() => {
    if (isDirty) {
      setIsConfirmOpen(true)
      return
    }
    onClose()
  }, [isDirty, onClose])

  const onKeepEditing = useCallback(() => {
    setIsConfirmOpen(false)
  }, [])

  const handleDiscard = useCallback(() => {
    setIsConfirmOpen(false)
    onClose()
  }, [onClose])

  const discardConfirmProps = useMemo(
    () => ({ isOpen: isConfirmOpen, onKeepEditing, onDiscard: handleDiscard }),
    [isConfirmOpen, onKeepEditing, handleDiscard]
  )

  return { handleCloseRequest, discardConfirmProps }
}

export default useDiscardConfirm
